import React, { useCallback, useMemo, useState } from 'react';

import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import { ModalInner } from '@components/wrapper/Modal/ModalStyle';
import BettingSettingForm from './BettingSettingForm';
import { IBettingItem } from '@typings/betting/betting.interface';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';
import { CollectionPath } from '@typings/collections.enum';
import fuego from '@store/firebase';
import { useRecoilValue } from 'recoil';
import { currentUserIDState } from '@atom/setting/user';
import useToast from '@hooks/useToast';
import { deleteItemsFromInventory, presentItem } from '@store/firebase/store/parchase-item';
import { IstoreItem } from '@typings/store/storeItem.interface';
import { ISkillItem } from '@typings/store/skill.interface';
import { IPhotoCard } from '@typings/photocard/photocard.interface';


type Props = {
  open: boolean;
  onClose: () => void;
  photocardData?: IPhotoCard;
  targetItemData?: IstoreItem | ISkillItem | any;
};

const defaultEditing: IBettingItem = {
  title: '',
  options: [],
  correctKey: '',
  announceAt: 0,
  createdAt: Date.now(),
  updatedAt: Date.now(),
  bettingHint: '',
};

function UseBettingItemModal({ open, onClose, photocardData, targetItemData, }: Props) {
  const [editing, setEditing] = useState<IBettingItem>(defaultEditing);
  const [announceDate, setAnnounceDate] = useState<Date | undefined>(undefined);
  const currentUserID = useRecoilValue(currentUserIDState);
  const { openToast } = useToast();

  const { id: photocardID, path: photocardPath } = photocardData || {};

  const handleSubmit = useCallback(
    async (payload: IBettingItem, announceTime: string) => {
      await fuego.firestore().collection(CollectionPath.DEMO_BETTING).add({
        ...payload,
        authorUid: currentUserID,
        status: 'pending',
        createdAt: Date.now(),
      });
      // 내 인벤토리에서 아이템 삭제
      if (targetItemData) {
        const inventoryPath = `${photocardPath}/${photocardID}/inventory`;
        await deleteItemsFromInventory({
          data: targetItemData,
          amount: 1,
          collectionPath: inventoryPath,
        });
      }
      openToast('베팅 주제 신청이 완료되었습니다.');
      onClose();
    },
    [currentUserID, onClose, openToast, photocardData, targetItemData],
  );


  return (
    <ModalWrapper outsideClick={onClose} contentStyle={{ minWidth: 420 }}>
      <ModalInner onClick={(e) => e.stopPropagation()}>
        <CloseBtn fixed onClick={onClose} size="md" />

        <BettingSettingForm
          editing={editing}
          setEditing={setEditing}
          announceDate={announceDate}
          setAnnounceDate={setAnnounceDate}
          onSaveAll={handleSubmit}
          hideDelete
          title='베팅 주제 만들기'
          saveText='베팅 주제 신청하기'
          style={{ padding: 0, border: 'none', backgroundColor: 'transparent' }}
        />
      </ModalInner>
    </ModalWrapper>
  );
}

export default UseBettingItemModal;


